import { render, staticRenderFns } from "./BotFooter.vue?vue&type=template&id=7cfed6f2&scoped=true"
import script from "./BotFooter.vue?vue&type=script&lang=js"
export * from "./BotFooter.vue?vue&type=script&lang=js"
import style0 from "./BotFooter.vue?vue&type=style&index=0&id=7cfed6f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfed6f2",
  null
  
)

export default component.exports